import { all, call, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import {
  setupIncomeOtpApi,
  verifyIncomeOtpApi,
} from "core/http/service/salary";
import type { IncomeOtpSectionRes } from "core/http/service/salary/resTypes";
import {
  rejectIncomeSectionOtp,
  resolveIncomeSectionOtp,
} from "core/http/incomeOtpBridge";
import {
  verifyIncomeOtpFailed,
  verifyIncomeOtpStart,
  verifyIncomeOtpSuccess,
} from "../redux/verifyIncomeOtp";

function* verifyIncomeOtpWork(action: ReturnType<typeof verifyIncomeOtpStart>) {
  const { otp, mode } = action.payload;
  try {
    const res = (yield call(
      mode === "setup" ? setupIncomeOtpApi : verifyIncomeOtpApi,
      otp
    )) as IncomeOtpSectionRes;

    yield put(verifyIncomeOtpSuccess({ section: res.section }));
    resolveIncomeSectionOtp(res.section);
    toast.success("Xác thực thành công.");
  } catch (err: unknown) {
    yield put(verifyIncomeOtpFailed());
    rejectIncomeSectionOtp(err);
    toast.error("Xác thực không thành công. Vui lòng thử lại.");
  }
}

function* watchVerifyIncomeOtp() {
  yield takeLatest(verifyIncomeOtpStart.type, verifyIncomeOtpWork);
}

export default function* verifyIncomeOtpSaga() {
  yield all([watchVerifyIncomeOtp()]);
}
